export default function () {
  document.querySelectorAll(".tooltip-icon").forEach((icon) => {
    const tooltip = icon.querySelector(".tooltip-text");
    icon.addEventListener("mouseover", () => {
      tooltip.style.display = "block";
    });
    icon.addEventListener("mouseout", () => {
      tooltip.style.display = "none";
    });
  });
}
